import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IContact, IContactInput } from '@ebb-v2/ebb-integration';
import { IEngineer } from '../../models/engineer.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class LicensedDesignProfessionalApiService {
  abstract checkLdpLicense(licenseNumber?: string | ''): Observable<IContact>;
  abstract getLdpListZip(zip: string): Observable<IEngineer[]>;
  abstract getLdpListFilter(filterString: string): Observable<IEngineer[]>;
  abstract saveLdpContact(contact: IContactInput): any;
}
